<script>
    import { onMount } from 'svelte';

    let consent;

    let cookiesAccepted;
   
    onMount( () => {
      // consent =  document.getElementById('cookieconsent');;
       let accept = localStorage.getItem('cookie_accept');
       console.log( "Cookies Accept = " + accept);
       if( accept ) {
            cookiesAccepted = 1;
       }
    });
    
    function acceptCookies() {
        
        localStorage.setItem('cookie_accept', 1);
       // consent.style.display="none";
        cookiesAccepted = 1;
    }

</script>
<style>
    footer {
        position: relative;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10vw 0 1vw 0;
       
    }
    ul {
        position: relative;
        z-index: 111;
    }
    ul li {
        display: inline;
        margin: 0 5px;
    }
    footer .waves {
        position: absolute;
        top: 0;
        width: 100%;
    }
    .brand {
        width: 50%;
        margin: auto;
        max-width: 300px;
        margin-bottom: 1em;
    }


 

</style>
<div style="text-align:center">
    <a  target="_blank" href="https://www.thesouthernco-operative.co.uk/"><img class="brand" src="/svg/south-coop-logo.svg" alt="southern-coop" /></a>
</div>
<footer>
    <div class="wrap">
        <ul>
            <li><a target="_blank" href="https://www.facebook.com/southerncoop"><img src="/svg/facebook.svg" alt="Facebook" /></a></li>
            <li><a target="_blank" href="https://twitter.com/TheSouthernCoop"><img src="/svg/x.svg" alt="Twitter" /></a></li>
            <li><a href="/contact"><img src="/svg/contact.svg" alt="Contact" /></a></li>
        </ul>
    </div>
     <img src="/svg/footer-waves.svg" class="waves" alt="Waves" aria-hidden="true" />
</footer>

{#if !cookiesAccepted}
<div id="cookieconsent" class="cookieConsentWrapper">
    <p><strong>Cookie Consent</strong>: We use cookies to offer a better browsing experience and analyze site traffic. Please review our <a target='_blank' href='https://www.thesouthernco-operative.co.uk/cookies/'>privacy policy page</a>. By clicking accept, you consent to our privacy policy &amp; use of cookies.<p>
    <button on:click={acceptCookies}>Accept cookies</button>
</div>
{/if}

